import { CustomFabricImage } from '../../../global-types/canvas';
import { isFabricImage } from './is-fabric-image';

export const getPhotoScale = (currentPhoto: CustomFabricImage): number => {
  if (isFabricImage(currentPhoto) && currentPhoto.data && typeof currentPhoto.data.scaleValue === 'number') {
    return currentPhoto.data.scaleValue;
  }
  return 100;
};
